<template>
  <div class="wrapper">
    <Header></Header>
    <main class="flex-fill">
      <router-view/>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: { Footer, Header },
  created()
  {
    this.$initialiseCookieConsent();
  }
}
</script>

<style lang="scss">
@import "./styles/theme";

.wrapper
{
  height: 100vh;
  display: flex;
  flex-direction: column;
}

main
{
  flex: 1;
}
</style>
